import { render, staticRenderFns } from "./DeviceConfig.vue?vue&type=template&id=cc76006c&scoped=true"
import script from "./DeviceConfig.vue?vue&type=script&lang=ts"
export * from "./DeviceConfig.vue?vue&type=script&lang=ts"
import style0 from "./DeviceConfig.vue?vue&type=style&index=0&id=cc76006c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc76006c",
  null
  
)

export default component.exports